module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-item"
  }, [_c('div', {
    staticClass: "activity-item-body"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "activity-item-section",
    class: {
      md5: _vm.activityItem.sender.recent_reposts,
      'no-reposts': !_vm.activityItem.sender.recent_reposts,
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "activity-item-section-body"
  }, [_c('v-flex', {
    staticClass: "activity-item-content-area",
    attrs: {
      "xs10": ""
    }
  }, [_c('profile-item', {
    attrs: {
      "user": _vm.activityItem.sender,
      "className": 'activity-item-profile-avatar-area'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activity-item-content"
  }, [_c('div', {
    class: {
      'd-block': _vm.onMobile,
      'dflex align-center': !_vm.onMobile,
    }
  }, [_c('user-tag', {
    staticClass: "user-name",
    attrs: {
      "user": _vm.activityItem.sender
    }
  }), _vm._v(" "), (!_vm.onMobile) ? _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("●")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "activity-time"
  }, [_vm._v(_vm._s(_vm._f("formatDateFromNow")(_vm.toLocalTimeString(_vm.activityItem.updated_at))))])], 1), _vm._v(" "), _c('label', {
    staticClass: "description-text align-center"
  }, [(_vm.activityIcon) ? _c('v-icon', {
    staticClass: "activityIcon mr-2"
  }, [_vm._v("\n                  " + _vm._s(_vm.activityIcon) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.activityItem.message)))])], 1)])], 1), _vm._v(" "), (_vm.activityItem.action_type == 'comment' || _vm.activityItem.assoc) ? _c('v-flex', {
    staticClass: "details",
    attrs: {
      "xs2": ""
    }
  }, [(_vm.activityItem.assoc) ? [(_vm.activityItem.assoc_type == 'Comment') ? [(_vm.activityItem.assoc.commentable_type == 'ShopProduct') ? _c('div', {
    staticClass: "actioned-item",
    style: ({
      'background-image': 'url(' +
        _vm.activityItem.assoc.commentable.covers[0].cover.thumb
        .url +
        ')',
    })
  }) : (_vm.activityItem.assoc.commentable_type == 'Album') ? _c('div', {
    staticClass: "actioned-item",
    style: ({
      'background-image': 'url(' +
        _vm.activityItem.assoc.commentable.cover.thumb.url +
        ')',
    })
  }) : (_vm.activityItem.assoc.commentable_type == 'Post') ? _c('div', {
    staticClass: "actioned-item",
    style: ({
      'background-image': 'url(' +
        _vm.activityItem.assoc.commentable.cover.thumb.url +
        ')',
    })
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.activityItem.assoc_type == 'Post') ? _c('div', {
    staticClass: "actioned-item",
    style: ({
      'background-image': 'url(' + _vm.activityItem.assoc.cover.thumb.url + ')',
    })
  }) : _vm._e(), _vm._v(" "), (_vm.activityItem.assoc_type == 'ShopProduct') ? _c('div', {
    staticClass: "actioned-item"
  }, [_c('activity-product-card', {
    attrs: {
      "object": _vm.activityItem.assoc
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activityItem.assoc_type == 'Album') ? _c('div', {
    staticClass: "actioned-item"
  }, [_c('activity-album-card', {
    attrs: {
      "object": _vm.activityItem.assoc
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activityItem.assoc_type == 'Video') ? _c('div', {
    staticClass: "actioned-item __video"
  }, [_c('video-box', {
    attrs: {
      "hoverOverlay": false,
      "coverOnly": "",
      "item": _vm.testVid
    }
  })], 1) : _vm._e()] : _vm._e()], 2) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), (_vm.showMerchModal && _vm.activityItem.assoc_type === 'ShopProduct') ? _c('merch-modal', {
    attrs: {
      "item": _vm.activityItem.assoc,
      "dismiss": _vm.dimissMerchModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41da1ec1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activityitem.vue
// module id = 1698
// module chunks = 180